import React, { useEffect, useState } from "react";
import HeaderLogo from "../../components/HeaderLogo";
import Footer from "../../components/Footer";
import { useDispatch, useSelector } from "react-redux";
import { getClientKYCLink } from "../../redux/actions/lookups/getClientKYCLink";
import LoadingSpinner from "../../components/Common/LoadingSpinner";
import KYCRequiredCard from "../../components/KYC/KYCRequiredCard";
import { SmallButton } from "../../components/Buttons";
import { setPageTitle } from "../../helper/metaDataHelper";
import { logout, UpdateRequestedKYC } from "../../redux/actions/auth";
import KYCError from "../../components/KYC/KYCError";
import { useModules } from "../../hooks";
import { checkClientKYCStatus } from "../../redux/actions/lookups/checkClientKYCStatus";

const KYCRequired = () => {
  const [loading, setLoading] = useState(false);
  const [isPolling, setIsPolling] = useState(false);
  const [error, setError] = useState(false);
  const [kycLink, setKycLink] = useState("");
  const dispatch = useDispatch(); // useDispatch is a hook provided by react-redux to dispatch actions
  const isSumSubEnabled = useModules("Sumsub");
  const { user } = useSelector((state) => state.user);
  const [requirements, setRequirements] = useState(null);

  const getKycLink = async () => {
    setLoading(true);
    const res = await dispatch(getClientKYCLink());

    if (res.success === true) {
      setKycLink(res.kyc_link);
      setRequirements({
        passport: res.request_passport,
        selfie: res.request_selfie,
        questionnaire: res.request_questionnaire,
        reason: res.reason,
      });
      setError(false);
    } else {
      setError(res.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!kycLink) getKycLink();
    setPageTitle("KYC Required");
    // eslint-disable-next-line
  }, [kycLink]);

  useEffect(() => {
    let interval;
    if (isPolling) {
      interval = setInterval(async () => {
        const res = await dispatch(checkClientKYCStatus());
        
        if (res && res.success) {
          if (
            res.status === "pending" ||
            res.status === "completed" ||
            res.status === "approved" ||
            res.kyc_requested === 0
          ) {
            setIsPolling(false);
            dispatch(UpdateRequestedKYC({ ...user, kyc_requested: 0 }));
          }
        }
      }, 20000); // 20 seconds
    }

    // Cleanup interval on unmount
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isPolling, dispatch, user]);

  const handleKYCRedirection = () => {
    if (!kycLink) return;
    if (isSumSubEnabled) {
      window.open(kycLink, "_blank");
      setIsPolling(true); // Start polling for KYC status
    } else {
      window.location.href = kycLink;
    }
  };

  const handleLogout = async () => {
    setLoading(true);
    await dispatch(logout());
    setLoading(false);
  };
  return (
    <>
      <HeaderLogo />
      <div className="max-w-[1024px] mx-auto space-y-4 px-4 min-h-[80vh]">
        <div className="inline-flex space-x-2 px-2 pb-8">
          <SmallButton onClick={handleLogout} text={"Logout"} cancel={true} />
        </div>
        <div className="flex items-center justify-center">
          {error ? (
            <KYCError error={error} />
          ) : isPolling ? (
            <div className="flex flex-col items-center justify-center bg-background-base shadow-lg px-4 py-12 rounded-3xl max-w-lg w-full">
              <LoadingSpinner />
              <h3 className="mt-6 text-2xl font-bold text-center text-primary-600">
                Waiting for Verification...
              </h3>
              <p className="text-center mt-3 text-gray-500">
                Please complete your verification in the newly opened tab. This
                page will update automatically.
              </p>
            </div>
          ) : (
            <KYCRequiredCard handleKYCRedirection={handleKYCRedirection} requirements={requirements} />
          )}
        </div>
      </div>

      {loading && !isPolling && <LoadingSpinner />}
      <Footer />
    </>
  );
};

export default KYCRequired;
